module.exports = __webpack_public_path__ + "static/media/robot.9a121d56.png";